function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.5.764h240v240H.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.789 57.229c11.94-3.2 25.994 6.77 36.72 19.696-5.353 12.097-8.515 25.105-8.515 34.84 0 12.439 5.163 23.673 13.462 31.676a38.17 38.17 0 01-16.173 8.934c-20.461 5.482-41.492-6.66-46.975-27.121-5.482-20.462 1.02-62.543 21.48-68.025zM155.937 76.69c10.7-12.81 24.657-22.641 36.524-19.461 20.461 5.482 26.963 47.563 21.48 68.025-5.482 20.46-26.513 32.603-46.974 27.12a38.186 38.186 0 01-16.307-9.057c8.225-7.995 13.334-19.177 13.334-31.553 0-9.679-3.125-22.595-8.422-34.633z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.994 155.764c24.3 0 44-19.7 44-44s-19.7-69-44-69-44 44.7-44 69c0 24.3 19.7 44 44 44z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.86 72.264l-.488 5.664c1.802.344 3.384.896 4.745 1.659 1.489.833 2.788 1.777 3.896 2.83l.406.386-.308.469-1.695 2.578c-.302.433-.615.77-.945 1.006-.38.272-.834.406-1.343.406-.39 0-.813-.113-1.278-.33a40.631 40.631 0 01-1.341-.658c-.484-.247-1.02-.5-1.607-.758a9.8 9.8 0 00-1.126-.41l-.87 10.327c1.185.374 2.36.78 3.524 1.219 1.377.52 2.62 1.192 3.729 2.018a9.917 9.917 0 012.753 3.154c.715 1.28 1.067 2.862 1.067 4.734 0 1.826-.304 3.545-.913 5.152a12.69 12.69 0 01-2.682 4.279c-1.175 1.238-2.617 2.24-4.323 3.008-1.552.697-3.299 1.14-5.24 1.332l-.291 3.577c-.05.586-.302 1.122-.736 1.594-.467.507-1.086.764-1.81.764h-3.282l.513-6.127a21.694 21.694 0 01-5.727-1.765c-1.985-.932-3.681-2.092-5.084-3.48l-.395-.39.31-.461 2.131-3.18c.245-.369.57-.67.967-.899a2.576 2.576 0 011.302-.357c.547 0 1.105.185 1.672.537.473.295 1.011.64 1.615 1.037.577.38 1.24.763 1.987 1.147.527.27 1.132.49 1.816.658l.956-11.314a43.994 43.994 0 01-3.474-1.19 13.88 13.88 0 01-3.685-2.115c-1.115-.897-2.013-2.03-2.692-3.391-.687-1.378-1.025-3.075-1.025-5.087 0-1.517.303-2.999.908-4.442a11.796 11.796 0 012.632-3.864c1.146-1.13 2.553-2.058 4.217-2.784 1.515-.662 3.224-1.062 5.125-1.203l.258-2.97c.05-.605.304-1.15.743-1.615.467-.495 1.083-.745 1.804-.745h3.284zm-2.606 31.108l-.81 9.703c1.43-.301 2.519-.86 3.283-1.67.896-.949 1.347-2.195 1.347-3.777 0-.619-.107-1.145-.315-1.586a3.803 3.803 0 00-.91-1.21 6.241 6.241 0 00-1.459-.966 15.046 15.046 0 00-1.136-.494zm-4.11-18.434a8.252 8.252 0 00-1.64.483c-.66.28-1.19.616-1.595 1.007-.4.384-.686.805-.865 1.266-.185.476-.277.98-.277 1.517 0 .623.103 1.159.306 1.613.208.465.5.877.877 1.24.397.38.868.722 1.417 1.023.332.182.683.354 1.054.516l.723-8.665z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M234.077 121.78c-11.719 43.5-58.346 76-114.083 76-55.736 0-102.363-32.5-114.082-76 11.719 11.777 58.346 20.577 114.082 20.577 55.534 0 102.024-8.736 113.953-20.45l.13-.127z",
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#6D4C41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M237.074 116.817c.715-3.031-6.159-4.06-20.622-3.084-1.584 2.506-2.837 8.424-3.758 17.755 6.619-2.675 11.717-4.498 15.296-5.47 3.578-.971 6.606-4.038 9.084-9.2z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.535 156.28c34.099 3.04 59.015 6.401 74.75 10.084s37.818 11.321 66.25 22.916",
  stroke: "#371447",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.494 140.16c-22.06 4.91-40.338 10.933-54.832 18.07-14.493 7.138-29.049 16.948-43.668 29.43",
  stroke: "#371447",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.752 142.017c15.575 8.676 29.52 15.015 41.833 19.015 12.313 4 28.783 7.544 49.41 10.629",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.494 135.16c-3.084 10.08-6.692 18.355-10.823 24.829-4.13 6.474-11.69 15.698-22.677 27.672m-54 9.999c-19.391-11.895-33.28-21.467-41.666-28.715-8.386-7.248-17.83-17.843-28.334-31.784",
  stroke: "#371447",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.994 161.16c-4.45-4.727-8.522-8.477-12.218-11.25-3.696-2.77-9.623-6.52-17.782-11.25",
  stroke: "#371447",
  strokeWidth: 3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.05 117.164c-.715-3.03 6.16-4.059 20.622-3.084 1.584 2.506 2.837 8.425 3.759 17.756-6.62-2.676-11.718-4.499-15.296-5.47-3.578-.972-6.606-4.039-9.084-9.202z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-158 116.46 45.649)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-158 111.644 47.307)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-158 106.828 48.965)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-158 102.012 50.624)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-158 97.196 52.282)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
}))), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "scale(1 -1) rotate(22 354.967 18.85)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(1 -1) rotate(22 363.498 43.627)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(1 -1) rotate(22 372.03 68.403)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(1 -1) rotate(22 380.56 93.18)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(1 -1) rotate(22 389.092 117.957)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
}))));

function SvgRetirementXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRetirementXl;